import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateWebsiteForm {
  public domain: string = '';
  public originServer: string = '';
  public userId: string = '';
  public groupId: number | null | undefined = null;
  public planId: number | null | undefined = null;
  public excludeActions: string[] = [];

  public rules: { [key: string]: FormValidationFunction[] } = {
    originServer: [
      (v: string) => !!v || 'Server is required',
      (v: string) => v.length > 1 || 'Server should be at least 2 characters long',
    ],
    domain: [
      (v: string) => !!v || 'Domain is required',
      (v: string) => !!v.match(/^(?!:\/\/)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/) || 'Invalid Domain',
      (v: string) => v.length < 201 || 'Domain maximum length is 200',
    ],
    plan: [
      (v: number) => !!v || 'Plan is required',
    ],
  };
}
